import { ArrowUpOutlined, PauseCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';

export const SendButton = ({
  busy,
  disabled,
  gradientBorder,
  focused,
  height,
  handleSubmit,
  label,
}: {
  busy: boolean;
  disabled: boolean;
  gradientBorder: boolean;
  focused: boolean;
  height: number;
  handleSubmit: () => void;
  label?: React.ReactNode;
}) => {
  if (label) {
    return (
      <button
        className="chat-collapsed-bar__ask-btn"
        onClick={handleSubmit}
        disabled={disabled}
        type="button"
      >
        {label}
      </button>
    );
  }

  return (
    <Button
      className="send-button"
      onClick={handleSubmit}
      type="primary"
      size="small"
      shape="circle"
      icon={
        busy ? (
          <PauseCircleOutlined style={{ color: '#999' }} />
        ) : (
          <ArrowUpOutlined
            style={{
              color:
                gradientBorder && focused ? '#fff' : undefined,
            }}
          />
        )
      }
      style={{
        height: height - 20,
        width: height - 20,
        boxShadow: 'none',
        border: 0,
        ...(busy ? { background: 'transparent' } : {}),
        ...(gradientBorder && focused
          ? {
              background: `linear-gradient(58deg, rgba(var(--theme-gradient-input-start),${
                focused ? 1 : 0.5
              }) 0%, rgba(var(--theme-gradient-input-end),${focused ? 1 : 0.5}) 100%)`,
            }
          : {}),
      }}
      disabled={disabled}
    />
  );
};
